import UserCardLogged from './UserCardLogged';

export default UserCardLogged;


// WEBPACK FOOTER //
// ./src/pages/chat/conversations/user-card-logged/index.js